<template>
  <div class="dropdown-parent-container">
    <button
      type="button"
      :title="memberName"
      class="dropdown-menu-toggle-arrow-icon-button sc3-button"
      id="member-dropdown-menu-toggle-button"
      :class="{ 'dropdown-menu-toggle-arrow-icon-button-open sc3-button-active': isOpen }"
      ref="memberDropdownMenuToggleButtonNode"
      @click="toggleDropdown()"
    >
      <i class="fas fa-fw fa-user-circle"></i>
      <span class="small-desktop-hidden">&nbsp;{{ memberName }}&nbsp;</span>
      <i class="far fa-fw fa-angle-down"></i>
    </button>
    <DropdownMenu
      :nodes-excluded-from-closing-on-outside-click="memberDropdownMenuToggleButtonNode ? [memberDropdownMenuToggleButtonNode] : []"
      :dropdown-button-left-value="left"
      v-model:is-open="isOpen"
      v-model:max-body-height="dropdownHeight"
      :dropdown-menu-toggle-button-node="memberDropdownMenuToggleButtonNode"
    >
      <template v-slot:body>
        <ul>
          <li>
            <a id="member-dropdown-menu-your-dashboard-button" href="/panels" target="_blank" @click="closeDropdown()">
              <i class="far fa-fw fa-tachometer-alt-fast"></i>
              &nbsp;Your Dashboard
            </a>
          </li>
          <li class="dropdown-divider"></li>
          <li>
            <a href="/panels#chartlists" target="_blank" @click="closeDropdown()">
              <i class="fas fa-fw fa-user-chart"></i>
              &nbsp;Your ChartLists
            </a>
          </li>
          <li>
            <a href="/def/servlet/ScanUI" target="_blank" @click="closeDropdown()">
              <i class="fal fa-fw fa-sliders-h"></i>
              &nbsp;Your Scans
            </a>
          </li>
          <li>
            <a href="/h-mem/useralertsummary.html" target="_blank" @click="closeDropdown()">
              <i class="far fa-fw fa-bell"></i>
              &nbsp;Your Alerts
            </a>
          </li>
          <li class="dropdown-divider"></li>
          <li>
            <a href="/youracct" target="_blank" @click="closeDropdown()">
              <i class="fas fa-fw fa-cogs"></i>
              &nbsp;Your Account
            </a>
          </li>
          <li class="dropdown-divider"></li>
          <li>
            <a href="//help.stockcharts.com" target="_blank" rel="noopener noreferrer" @click="closeDropdown()">
              <i class="fas fa-fw fa-question-circle"></i>
              &nbsp;Support Center
            </a>
          </li>
          <li>
            <a href="/support/techsupport.html" target="_blank" @click="closeDropdown()">
              <i class="far fa-fw fa-envelope"></i>
              &nbsp;Contact Us
            </a>
          </li>
          <li class="dropdown-divider"></li>
          <li>
            <a href="/logout" @click="closeDropdown()">
              <i class="fas fa-fw fa-sign-out-alt"></i>
              &nbsp;Log Out
            </a>
          </li>
        </ul>
      </template>
    </DropdownMenu>
  </div>
</template>

<script lang="ts" setup>
  import { ref, watch } from 'vue';
  import { useAuthentication } from '@/composables/useAuthentication';
  import { useBoundingClientRect } from '@/composables/useBoundingClientRect';
  import DropdownMenu from '@/components/dropdowns/DropdownMenu.vue';

  const { memberName } = useAuthentication();
  const { getBoundingClientRectPropertyRefs } = useBoundingClientRect();
  const memberDropdownMenuToggleButtonNode = ref<HTMLButtonElement>();
  const isOpen = ref<boolean>(false);
  const dropdownHeight = ref<number>(0);
  const { left } = getBoundingClientRectPropertyRefs(memberDropdownMenuToggleButtonNode, { windowResize: true });

  function toggleDropdown() {
    isOpen.value = !isOpen.value;
  }

  function closeDropdown() {
    isOpen.value = false;
  }

  watch(isOpen, () => {
    if (!isOpen.value) {
      memberDropdownMenuToggleButtonNode.value?.blur();
    }
  });
</script>

<style scoped>
  .dropdown-parent-container {
    position: relative;
  }

  #member-dropdown-menu-toggle-button {
    font-size: 18px;
    background-color: transparent;
    border-color: transparent;
    color: #d0dbe2;
    display: block;
    border-radius: 4px;
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 15px;
    line-height: 21px;
    height: 35px;
    margin: 5px 0px 0px 0px;
  }

  #member-dropdown-menu-toggle-button:hover,
  #member-dropdown-menu-toggle-button:active,
  #member-dropdown-menu-toggle-button:focus,
  #member-dropdown-menu-toggle-button.sc3-button-active {
    color: white;
  }

  ul {
    max-height: v-bind('`${dropdownHeight}px`');
  }

  #member-dropdown-menu-your-dashboard-button {
    font-weight: 900;
    color: #219155;
  }

  @media (max-width: 767px) {
    #member-dropdown-menu-toggle-button {
      margin-top: 0px;
    }
  }
</style>
